module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_harjedalen-951ea7c7f9cb25b3df31af98eaeef7de.png";